<template>
  <gj-tree-manager
      title="品类结构"
      :loading="loading"
      :data="data"
      collapse-icon
      homeIcon
      expand-icon
      @queryData="queryData"
      @node-click="select"
  ></gj-tree-manager>
</template>

<script>
  import {getProductCategoryTree} from "../../../../../api/product";
  import {productCategoryStore} from "../store";

  export default {
    name: "app-product-category-tree",
    data() {
      return {
        loading: false,
        data: [],
        curNodeId: null,
        nodeYes:{
          isCurrent:false
        },
      }
    },
    created() {
      this.refresh();
    },
    methods: {
      refresh() {
        this.loading = true;
        getProductCategoryTree()
          .then((data) => {
            productCategoryStore.tree = this.data = data;
          })
          .complete(() => this.loading = false);
      },
      queryData() {
          this.nodeYes.isCurrent = false;
          this.$emit('select', this.curNodeId = null);
      },
      select(data, node) {
        if (data) {
        // if (data && this.curNodeId !== data.id) {
          this.$emit('select', this.curNodeId = data.id);
          node.isCurrent = true;
          this.nodeYes=node
        }
        // else {
        //   this.nodeYes.isCurrent = false;
        //   this.$emit('select', this.curNodeId = null);
        // }
      }
    }
  }
</script>

<style lang="scss" scoped>
  ///deep/ .el-input{
  //  width: 100% !important;
  //}
  /deep/ .top-input{
    padding: 12px;
    display: flex;
    align-items: center;
    .el-button {
      top: 0 !important;
      min-width: 32px;
      min-height: 32px;
    }
    .el-input{
      width: 100% !important;
    }
  }
</style>
